import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import s from "./Spin.module.scss";
import useColors from "utils/useColors/useColors";

const Spin = ({ type, hover }) => {
  const c = useColors();

  return (
    <div
      className={[s.spinning, type === "search" ? s.searching : ""].join(" ")}
      {...(hover && { style: { zIndex: "1000" } })}
    >
      <CircularProgress
        sx={{
          color: c.brand1,
        }}
      />
    </div>
  );
};

export default Spin;
